module.exports = __webpack_public_path__ + "static/media/400075_01.1d4edfe3.png";